import { useAuthStore } from "stores/useAuthStore";

const buildQueryString = (params: Record<string, unknown>) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null) query.append(key, String(value));
  });
  return query.toString() ? `?${query.toString()}` : "";
};

const request = async <TRequest = unknown>(
  method: string,
  url: string,
  body?: TRequest,
  params: Record<string, unknown> = {},
  signal?: AbortSignal
): Promise<Response> => {
  const token = useAuthStore.getState().accessToken;

  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const isFormData = body instanceof FormData;
  if (!isFormData && body !== undefined) {
    headers["Content-Type"] = "application/json; charset=UTF-8";
  }

  if (["GET", "DELETE"].includes(method)) {
    url += buildQueryString(params);
  }

  const config: RequestInit = { method, headers, signal };

  if (!["GET", "DELETE"].includes(method) && body !== undefined) {
    config.body = isFormData ? (body as any) : JSON.stringify(body);
  }

  return fetch(url, config);
};

export const client = {
  get: (
    url: string,
    params: Record<string, unknown> = {},
    signal?: AbortSignal
  ) => request("GET", url, undefined, params, signal),

  post: <TRequest = unknown>(
    url: string,
    body?: TRequest,
    signal?: AbortSignal
  ) => request<TRequest>("POST", url, body, {}, signal),

  put: <TRequest = unknown>(
    url: string,
    body?: TRequest,
    signal?: AbortSignal
  ) => request<TRequest>("PUT", url, body, {}, signal),

  patch: <TRequest = unknown>(
    url: string,
    body?: TRequest,
    signal?: AbortSignal
  ) => request<TRequest>("PATCH", url, body, {}, signal),

  delete: (
    url: string,
    params: Record<string, unknown> = {},
    signal?: AbortSignal
  ) => request("DELETE", url, undefined, params, signal),

  download: (url: string, params: Record<string, unknown> = {}) => {
    const query = buildQueryString(params);
    window.open(url + query, "_blank");
    return true;
  },
};
